<template>
  <div class="account_set_wrap" v-loading="loading">
    <div class="account_set_header">
      <h2>修改密码</h2>
    </div>
    <div class="account_set_content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="当前密码：" prop="currentPassword">
          <el-input v-model.trim="ruleForm.currentPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input v-model.trim="ruleForm.newPassword" maxLength="18"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码：" prop="repeatPassword">
          <el-input v-model.trim="ruleForm.repeatPassword" maxLength="18"></el-input>
        </el-form-item>
        <el-button class="submit" @click="submitForm('ruleForm')">提交</el-button>
      </el-form>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="show"
      width="420px"
      :before-close="clickConfirm"
      class="submit_dialog"
      :close-on-click-modal="false">
      <div class="dialog_content">
        <img src="../../../../../static/images/success.png" alt="加载失败"/>
        <div>
          <h2>修改成功</h2>
          <p>请重新登录系统</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="padding:0" @click="clickConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as api from '../../../../api/userApi'
import AES from "../../../../utils/AES.js";
export default {
  data() {
    var validator = (rule, value, callback) => {
      if (value==null || value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      height: window.innerHeight,
      loading: true,
      ruleForm: {
        currentPassword: null,
        newPassword: null,
        repeatPassword: null,
        passwordType: 'power',
      },
      rules: {
        currentPassword: [
          {required: true, message: '请输入当前密码', trigger: 'blur'}
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          { validator: (rule, value, callback) => {
              var reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,16}$/;
              if (!reg.test(value)) {
                  callback(new Error('密码包含大小写字母、数字、特殊符号其中的三种或三种以上、长度在 8 到 16 个字符'));
              } else {
                  callback();
              }
            }, trigger: 'blur' }
        ],
        repeatPassword: [
          // {required: true, message: '请输入重复新密码', trigger: 'blur'},
          { required: true, validator: validator, trigger: 'blur' }
        ],
      },
      show: false
    };
  },
  created() {
    this.loading = false
    if(localStorage.getItem('tokenFlag')=='false'){
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/home');
      localStorage.setItem('tokenFlag',true)
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.newPassword !== this.ruleForm.repeatPassword) {
            this.$messageError("两次输入密码不一致!");
            return false;
          }
          if(this.ruleForm.newPassword == '123456'){
            this.$messageError("密码不能为123456!");
            return false;
          }
          this.change(this.ruleForm);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    change(params) {
      let {currentPassword, newPassword} = params;
      let obj = {
          password:  AES.encrypt(currentPassword),
          newPassword:  AES.encrypt(newPassword),
          passwordType: 'power',
      };
      api.updatePassword(obj).then(res => {
        if (res.code == 0) {
          this.show=true;
          localStorage.setItem('tokenFlag',false);
        } else {
          this.$messageError(res.msg);
        }
      }).catch(error => {
        console.log(error);
      })
    },
    clickConfirm(){
      this.show = false
      api.updatePasswordLogout(localStorage.getItem('Authorization')).then((rs)=>{
        if(rs.code==0){
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('tokenFlag',true)
          this.$router.push('/home');
        }else{
          this.$messageError(rs.msg)
        }
      }).catch((error)=>{
          console.log(error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.account_set_wrap {
  .account_set_content{
    border-top: 1px solid #fff;
  }
  /deep/ .submit_dialog{
    .el-dialog{
      background:rgba(255,255,255,1);
      opacity:1;
      border-radius:8px;
      .el-dialog__header{
        height:48px;
        background:rgba(237,244,255,1);
        padding: 20px 15px 0 15px;
        box-sizing:border-box;
        border-radius: 8px 8px 0 0;
        span{
          display: block;
          font-size:14px;
          font-weight:400;
          color:rgba(83,151,247,1);
          border-left: 2px solid #5397F7;
          line-height:10px;
          padding-left: 5px;
        }
        .el-dialog__headerbtn{
          top:18px;
        }
      }
      .el-dialog__body{
        padding: 30px 30px 0;
        .dialog_content{
          display: flex;
          align-items: center;
          margin: 20px 0 30px;
          justify-content: center;
          img{
            width: 40px;
            height: 40px;
            margin-left: 10px;
          }
          img+div{
            max-width: 280px;
            margin-left: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-right: 20px;
            h2{
              font-size:16px;
              font-weight:400;
              color:rgba(51,51,51,1);
            }
            p{
              margin-top: 4px;
              font-size:14px;
              font-weight:400;
              color:rgba(51,51,51,1);
            }
          }
        }
      }
      .el-dialog__footer{
        margin-bottom: 20px;
        button{
          width:80px;
          height:32px;
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          font-size:14px;
          font-weight:400;
          color:rgba(83,151,247,1);
          padding: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/changePassword.vue